import './index.css';    
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { getStoredLanguage } from './i18n/lang'

// Enable keyboard-only focus styles by toggling a class on the root element
if (typeof window !== 'undefined') {
  const enableTabbing = () => document.documentElement.classList.add('user-tabbing');
  const disableTabbing = () => document.documentElement.classList.remove('user-tabbing');

  window.addEventListener('keydown', (e) => {
    if (
      e.key === 'Tab' ||
      e.key === 'ArrowUp' ||
      e.key === 'ArrowDown' ||
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight'
    ) {
      enableTabbing();
    }
  });
  window.addEventListener('mousedown', disableTabbing);
  window.addEventListener('touchstart', disableTabbing);

  const w = window as unknown as { fetch: typeof window.fetch; __langFetchWrapped?: boolean };
  if (!w.__langFetchWrapped) {
    const originalFetch = w.fetch.bind(window);
    w.fetch = (input: RequestInfo | URL, init: RequestInit = {}) => {
      const headers = new Headers(init.headers || {});
      const lang = getStoredLanguage();
      if (lang) headers.set('Accept-Language', lang);
      return originalFetch(input, { ...init, headers });
    };
    w.__langFetchWrapped = true;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
